import { Grid } from "@mui/material";
import PageHeader from "app/frontend/components/PageHeader";

const EligibilityHeader = () => {
    return (
        <Grid size={12}>
            <PageHeader
                pageName="Eligibility Assessment guide"
                title="Check Your Project's Eligibility for PowerReady Incentives"
                description="Find out if your project qualifies for PowerReady program incentives and take the first step toward clean energy solutions."
            />
        </Grid>
    );
};

export default EligibilityHeader;
